import type { Locale } from '@/i18n'

const normalizeSearchText = (value: string, locale: Locale): string =>
  value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase(locale).trim()

export const filterAuthorStories = <Story extends { title: string }>(
  stories: Story[],
  query: string,
  locale: Locale
): Story[] => {
  const terms = normalizeSearchText(query, locale).split(/\s+/).filter(Boolean)
  if (terms.length === 0) return stories

  return stories.filter((story) => {
    const title = normalizeSearchText(story.title, locale)
    return terms.every((term) => title.includes(term))
  })
}
